import React from 'react';
import WhyUsBox from './WhyUsBox';
import '../styles/whyus.css';
import { Helmet ,HelmetProvider} from "react-helmet-async";

const WhyUs = () => {
  const boxesData = [
    {
      iconSrc: '/assets/search.svg',
      altText: 'Innovative Approach',
      title: 'Innovative Approach',
      description:"We create game-changing solutions. "
    },
    {
      iconSrc: '/assets/smile.svg',
      altText: 'User-Centric Design',
      title: 'User-Centric Design',
      description: 'Built for ease of use and efficiency.'
    },
    {
      iconSrc: '/assets/world.png',
      altText: 'Global Quality + Local Understanding',
      title: 'Global Quality + Local Understanding',
      description: 'World-class products tailored to local needs.'
    },
];

const boxesData2 = [
    
  {
    iconSrc: '/assets/Domain Expertise.png',
      altText: 'Domain Expertise Across Industries',
      title: 'Domain Expertise Across Industries',
      description:  (
        <ul>
          <li>
            ERP (Inventory, Projects, Manufacturing) 
          </li>
          <li>
            Accounting & GST 
          </li>
          <li>
            Healthcare (Hospital, Lab, Clinic Management with HL7) 
          </li>
          <li>
            Hospitality (Restaurant, Bar, Lodge)
          </li>
          <li>
            HRM, CRM, Payroll 
          </li>
          <li>
            E-Commerce
          </li>
        </ul>
      )
  } ,
  
  {
    iconSrc: '/assets/customize product.png',
      altText: 'Specialized products we’ve developed ',
      title: 'Specialized products we’ve developed ',
      description: (
    <ul>
      <li>
        Inventory, Accounting and Billing Applications
      </li>
      <li>
        GST-enabled ERP Systems
      </li>
      <li>
        Construction Management ERP
      </li>
      <li>
        Pathology Reporting Software (HL7-enabled) 
      </li>
      <li>
        Hotel & Restaurant Management Systems 
      </li>
      <li>
        HRM, CRM, Payroll Systems 
      </li>
      <li>
        RFID Digital Door Lock Systems 
      </li>
      <li>
        Complete E-Commerce Platforms  
      </li>
      <li>
        Customized Desktop, Cloud and Mobile Applications 
      </li>
    </ul>
  )
  }
];

  return (
    <>
    <HelmetProvider>
      <Helmet>
  <meta
    name="description"
    content="Why choose INBI NextGen Innovations? Innovative software, user-centric design, global quality with local expertise, and years of industry experience across ERP, IoT, healthcare, hospitality, and more."
  />
  <meta name="keywords" content="why choose INBI, software innovation, IoT expertise, ERP systems India, industry-specific solutions" />

  {/* Open Graph */}
  <meta property="og:title" content="INBI NextGen Innovations – Custom Software, IoT & ERP Solutions in India"/>
  <meta property="og:description" content="INBI NextGen Innovations builds future-ready software, IoT, and ERP solutions tailored to your business needs. Over 27 
years of expertise. Contact us today."/>
  <meta property="og:image" content="'/assets/Logoblue.jpg'" />
  <meta property="og:url" content="https://inbinextgen.com/#why-us" />
  <meta property="og:type" content="website" />

  {/* Twitter */}
 
  <meta name="twitter:title" content="INBI NextGen Innovations – Custom Software, IoT & ERP Solutions in India"/>
  <meta name="twitter:description" content="INBI NextGen Innovations builds future-ready software, IoT, and ERP solutions tailored to your business needs. Over 27 
years of expertise. Contact us today."/>
  <meta name="twitter:image" content="'/assets/Logoblue.jpg'" />
</Helmet>
    </HelmetProvider>
    

    <section id="why-us" className="why-us-section">
      <h2 className="section-heading"> Why Choose INBI NextGen Innovations</h2>
      <div className="why-us-container">
        {boxesData2.map((box, index) => (
          <WhyUsBox
            key={index}
            iconSrc={box.iconSrc}
            altText={box.altText}
            title={box.title}
            description={box.description}
          />
        ))}
        
      </div>
      <div className="why-us-container">
        {boxesData.map((box, index) => (
          <WhyUsBox
            key={index}
            iconSrc={box.iconSrc}
            altText={box.altText}
            title={box.title}
            description={box.description}
          />
        ))}
        
      </div>

    </section>
    </>
  );
};export default WhyUs;
